import React from "react";
import { isRemoteControl } from "../../utils/assessment-control";
import RemoteStartHint from "../RemoteStartHint";

interface Props {
  persistentMode?: boolean;
}

const AROMTherapistReadyModal: React.FC<Props> = ({ persistentMode = false }) => {
  return (
    <div className={`assessmet-complete-wrap counter-center-sec ${persistentMode ? 'persistent-mode' : ''}`}>
      <div className="assessmnet-text-wrap">
        {!persistentMode && (
          <p
            style={{
              fontSize: "64px",
              fontWeight: "700",
              lineHeight: "87.16px",
              textAlign: "center",
              marginBottom: "50px",
              color: "white",
            }}
          >
            Ready?
          </p>
        )}
        {isRemoteControl() ? (
          // The remote with Start/Stop highlighted instead of the hand-raise icon
          <RemoteStartHint height={persistentMode ? 300 : 640} />
        ) : (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="401"
            height="400"
            viewBox="0 0 401 400"
            fill="none"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M200.946 0C90.4888 0 0.945801 89.543 0.945801 200C0.945801 310.457 90.4888 400 200.946 400C311.403 400 400.946 310.457 400.946 200C400.946 89.543 311.403 0 200.946 0Z"
              fill="#802392"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M208.359 120.108C201.153 120.865 194.777 123.916 189.652 129.058C185.357 133.368 182.569 138.504 181.259 144.52C180.656 147.288 180.649 153.812 181.245 156.604C182.086 160.539 183.652 164.297 185.846 167.642C187.366 169.962 191.847 174.464 194.149 175.986C199.014 179.202 204.075 180.877 209.774 181.159C216.509 181.492 222.585 179.819 228.266 176.067C232.556 173.233 236.03 169.362 238.431 164.737C240.842 160.092 241.855 155.934 241.855 150.678C241.855 142.4 239.041 135.39 233.329 129.439C228.868 124.791 223.547 121.869 217.233 120.6C214.564 120.063 210.782 119.853 208.359 120.108ZM122.098 128.702C120.242 129.295 118.94 130.112 117.648 131.493C115.182 134.129 114.367 137.736 115.355 141.641C116.525 146.27 120.449 154.848 124.485 161.6C130.133 171.05 136.197 179.179 149.189 194.715C152.342 198.485 155.773 202.755 156.814 204.203C165.29 216.003 170.341 229.658 172.332 246.159C173.094 252.477 173.278 256.195 173.429 268.323L173.575 280H212.112H250.65L250.709 265.907L250.769 251.814L252.435 255.043C255.975 261.904 258.973 269.979 261.335 279.012L261.593 280H274.027H286.461L286.314 279.129C285.999 277.262 284.033 268.554 283.178 265.244C281.364 258.213 276.289 240.937 274.51 235.731C266.775 213.101 256.99 201.547 241.146 196.336C234.892 194.279 228.314 193.249 218.933 192.858C204.448 192.253 200.333 191.749 193.214 189.705C184.789 187.286 176.251 182.838 169.316 177.254C158.992 168.942 150.261 158.137 136.774 136.984C133.983 132.607 132.694 131.067 130.827 129.883C128.343 128.307 124.823 127.83 122.098 128.702Z"
              fill="white"
            />
          </svg>
        )}
      </div>
    </div>
  );
};
export default AROMTherapistReadyModal;
